const state = {
  errorDialog: null,
  confirmDialog: null,
  resultDialog: null,
  infoDialog: null,
  inputDialog: null,
  loadingReqNumber: 0,
  showStatusDialog: true,
  isRecordingVideo: false,
  toastCountDownConfirm: null,
  editBuilderFieldDialog: null
};

const mutations = {
  setErrorDialog(state, payload) {
    state.errorDialog = payload;
  },
  setConfirmDialog(state, payload) {
    state.confirmDialog = payload;
  },
  setResultDialog(state, payload) {
    state.resultDialog = payload;
  },
  setInfoDialog(state, payload) {
    state.infoDialog = payload;
  },
  setInputDialog(state, payload) {
    state.inputDialog = payload;
  },
  increaseLoadingReqNumber(state, payload) {
    state.loadingReqNumber += payload;
  },
  setShowStatusDialog(state, payload) {
    state.showStatusDialog = payload;
  },
  setIsRecordingVideo(state, payload) {
    state.isRecordingVideo = payload;
  },
  setToastCountDownConfirm(state, payload) {
    state.toastCountDownConfirm = payload;
  },
  setEditBuilderFieldDialog(state, payload) {
    state.editBuilderFieldDialog = payload;
  }
};

const actions = {
  setErrorDialog({ commit }, payload) {
    commit("setErrorDialog", payload);
  },
  setConfirmDialog({ commit }, payload) {
    commit("setConfirmDialog", payload);
  },
  setResultDialog({ commit }, payload) {
    commit("setResultDialog", payload);
  },
  setInfoDialog({ commit }, payload) {
    commit("setInfoDialog", payload);
  },
  setInputDialog({ commit }, payload) {
    commit("setInputDialog", payload);
  },
  increaseLoadingReqNumber({ commit }, payload) {
    commit("increaseLoadingReqNumber", payload);
  },
  updateShowStatusDialog({ commit }, payload) {
    commit("setShowStatusDialog", payload);
  },
  setIsRecordingVideo({ commit }, payload) {
    commit("setIsRecordingVideo", payload);
  },
  setToastCountDownConfirm({ commit }, payload) {
    commit("setToastCountDownConfirm", payload);
  },
  setEditBuilderFieldDialog({ commit }, payload) {
    commit("setEditBuilderFieldDialog", payload);
  }
};

const getters = {
  loadingReqNumber(state) {
    return state.loadingReqNumber;
  },
  errorDialog(state) {
    return state.errorDialog;
  },
  showStatusDialog: state => state.showStatusDialog,
  isRecordingVideo: state => state.isRecordingVideo,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogs.js